import React from 'react'
import { Redirect } from 'react-router'

import {
  userSetUser
} from '../../actions'
import TLServiceComponent from '../../contexts/TLServiceComponent'
import { useActions } from '../../utils/action-helper'

export default function AuthorizationRedirect () {
  const search = window.location.search
  const tlService = React.useContext(TLServiceComponent)
  const {
    aUserSetUser
  } = useActions({
    aUserSetUser: userSetUser(tlService),
  })

  const params = new URLSearchParams(search)
  const token = params.get('token')
  const error = params.get('error')

  if (token) {
    aUserSetUser({ token: token }, true)
    return <Redirect to={'/'}/>
  }

  return <Redirect to={`/authorization/error?error=${error}`}/>

}


